import { SxProps, Theme } from "@mui/material";

const styles: Record<string, SxProps<Theme>> = {
    wrapper: {
        mb: 2,
        width: "100%"
    },
    tryServersLink: {
        display: "inline",
        color: "primary.600",
        fontWeight: 600,
        cursor: "pointer",
        textDecoration: "underline"
    },
    tryServersFooter: {
        pt: 1.5,
        mt: 0.5,
        borderTop: "1px solid",
        borderColor: "greyscale.200"
    }
};

export default styles;
